import Vue from "vue";
import VueI18n from "vue-i18n";
import elementEnLocale from "element-ui/lib/locale/lang/en"; // element-ui lang
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN"; // element-ui lang
import enLocale from "./en";
import zhLocale from "./zh";
import { getStore } from "@/util/store";
Vue.use(VueI18n);
// 不再使用 window.AVUE，改用 npm 安装的 avue
const messages = {
  en: {
    ...enLocale,
  },
  zh: {
    ...zhLocale,
  },
};

const i18n = new VueI18n({
  locale: getStore({ name: "language" }) || "zh",
  messages,
});

export default i18n;
